import { render, staticRenderFns } from "./sendInterSms.vue?vue&type=template&id=ed15123a&"
import script from "./sendInterSms.vue?vue&type=script&lang=js&"
export * from "./sendInterSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports